import * as React from 'react'

type TimeDeltaContextType = {
  timeDeltas: Map<number, number>
  setTimeDelta: (recordId: number, delta: number) => void
  clearTimeDelta: (recordId: number) => void
  getTotalDelta: () => number
}

export const TimeDeltaContext = React.createContext<TimeDeltaContextType | null>(null)

export function TimeDeltaProvider({ children }: { children: React.ReactNode }) {
  const [timeDeltas, setTimeDeltas] = React.useState<Map<number, number>>(new Map())

  const setTimeDelta = React.useCallback((recordId: number, delta: number) => {
    setTimeDeltas(prev => {
      const newMap = new Map(prev)
      if (delta === 0) {
        newMap.delete(recordId)
      } else {
        newMap.set(recordId, delta)
      }
      return newMap
    })
  }, [])

  const clearTimeDelta = React.useCallback((recordId: number) => {
    setTimeDeltas(prev => {
      const newMap = new Map(prev)
      newMap.delete(recordId)
      return newMap
    })
  }, [])

  const totalDelta = React.useMemo(() => {
    let total = 0
    timeDeltas.forEach(delta => {
      total += delta
    })
    return total
  }, [timeDeltas])

  const getTotalDelta = React.useCallback(() => totalDelta, [totalDelta])

  const value = React.useMemo(
    () => ({
      timeDeltas,
      setTimeDelta,
      clearTimeDelta,
      getTotalDelta,
    }),
    [timeDeltas, setTimeDelta, clearTimeDelta, getTotalDelta]
  )

  return <TimeDeltaContext.Provider value={value}>{children}</TimeDeltaContext.Provider>
}

